import styled from "styled-components";

export const Label = styled.label`
  display: flex;
  margin-bottom: 20px;
  width: 300px;
  justify-content: space-between;
`;
